import moment from 'moment'

const state = {
  admins: [],
  companies: [],
  devices: [],
  deviceUsage: [],
  endDate: moment(),
  isLoading: false,
  numDates: 30,
  promotions: [],
  startDate: moment().subtract(29, 'days')
}

export default state
